<template>
    <div class="app">
        <div class="end-wrap">
            <h2>末端设备选型</h2>
            <ul>
                <li v-for="(fit, findex) in data.arrFloorArea" :key="fit.id">
                    <h3>
                        <div class="btns">
                            <span>{{ fit.room | roomNumber }}</span>
                            <div @click="openAddArea(findex)"></div>
                        </div>
                        <div class="btns">
                            <div class="del" @click="delRoom(fit.id, findex)"></div>
                        </div>
                    </h3>
                    <ol>
                        <li v-for="(rit, rindex) in fit.rooms_init" :key="rindex" v-show="!rit.noMatch"
                            :ref="'rooms'+rit.id">
                            <h4>
                                <div class="input-wrap">
                                    <input type="text" v-model="rit.name"/>
                                </div>
                                <div class="btns">
                                    <div :class="{ close: rit.isOpen }" class="open" @click="openRoomDetail(rit)">
                                        {{ rit.isOpen ? "收起详情" : "展开详情" }}
                                    </div>
                                    <div class="del" @click="delArea(findex, rindex)"></div>
                                </div>
                            </h4>
                            <div class="detail">
                                <div class="input-line">
                                    <div class="item">
                                        <span>面积</span>
                                        <div>
                                            <input type="number" @blur="count(findex, rindex, 1)" v-model="rit.area"/>m²
                                        </div>
                                    </div>
                                    <div :class="['item']">
                                        <span>朝向</span>
                                        <div :class="['select',data.selatShow&&rit.direction==''?'item-top':'']"
                                             @click="openBearing(findex, rindex)">
                                            <input type="text" v-model="rit.direction" readonly/>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-line">
                                    <div class="item line">
                                        <span>需求负荷</span>
                                        <p>冷</p>
                                        <div class="m nomodify">
                                            <input :value="rit.energy_cold? rit.energy_cold /1000: ''" class="s"
                                                   type="number" readonly/>KW
                                        </div>
                                    </div>
                                    <div class="item">
                                        <p>暖</p>
                                        <div class="m nomodify">
                                            <input :value="rit.energy_hot? rit.energy_hot /1000: ''" class="s"
                                                   type="number" readonly/>KW
                                        </div>
                                    </div>
                                </div>
                                <div class="type_list">
                                    <div class="type_item">末端设置:</div>
                                    <div class="type_item" v-for="(xitem, xinde) in rit.typeXuan" :key="xinde"
                                         v-show="xinde!=1">
                                        <div @click="getType(findex,rindex,xinde,xitem)"
                                             :class="[xitem.open? 'type_open': 'type_no_open',]"></div>
                                        <div>{{ xitem.name }}</div>
                                    </div>
                                </div>
                                <div class="goods-list">
                                    <h5 v-if="rit.arrWind.length">
                                        <span>末端设备配置</span>
                                    </h5>
                                    <div class="item" v-for="(wit, windex) in rit.arrWind" :key="windex">
                                        <div class="item_name">
                                            <div class="item_left">
                                                <span>{{ wit.mark }}</span>
                                                <span>{{ wit.goods_name }}<span class="num" v-if="wit.nNum > 1">x{{
                                                        wit.nNum
                                                    }}</span></span>
                                            </div>
                                            <div class="item_btn">
                                                <div class="shoppEdit"
                                                     @click="newEditWind(findex,rindex,windex,wit,rit.arrWind,rit.energy_cold)">
                                                    修改
                                                </div>
                                                <div v-if="rit.arrWind.length > 1" class="shoppDel"
                                                     @click="newDelWind(findex,rindex,windex)">删除
                                                </div>
                                            </div>
                                        </div>
                                        <div class="content">
                                            <div class="img-box">
                                                <img :src="wit.mobile_img"/>
                                            </div>
                                            <div class="parameter">
                                                <p v-for="(ait, aindex) in wit.attr_two" :key="aindex">
                                                    <span>{{ ait.attr_name }}:</span>
                                                    <span>{{ ait.attr_value }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-list" v-show="rit.isOpen">
                                    <div class="input-line">
                                        <div class="item">
                                            <span>层高</span>
                                            <div class="m">
                                                <input @blur="count(findex, rindex, 1)" v-model="rit.floor"
                                                       type="number"/>m
                                            </div>
                                        </div>
                                        <div class="item">
                                            <span>设计温度</span>
                                            <div class="m" @click="openwdPicker(findex, rindex)">
                                                <p>{{ rit.temperature }}</p>℃
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-line">
                                        <div class="item line">
                                            <span>单位负荷</span>
                                            <p>冷</p>
                                            <div class="m">
                                                <input class="s" @blur="count(findex, rindex, 1)"
                                                       v-model="rit.energy_cold_per" type="number"/>W
                                            </div>
                                        </div>
                                        <div class="item">
                                            <p>暖</p>
                                            <div class="m">
                                                <input class="s" @blur="count(findex, rindex, 1)"
                                                       v-model="rit.energy_hot_per" type="number"/>W
                                            </div>
                                        </div>
                                    </div>
                                    <div class="input-line">
                                        <div class="item line">
                                            <span>设计负荷</span>
                                            <p>冷</p>
                                            <div class="m nomodify">
                                                <input class="s" @blur="count(findex, rindex, 1)"
                                                       v-model="rit.energy_cold_per_warp" readonly type="number"/>w/㎡
                                            </div>
                                        </div>
                                        <div class="item">
                                            <p>暖</p>
                                            <div class="m nomodify">
                                                <input class="s" @blur="count(findex, rindex, 1)"
                                                       v-model="rit.energy_hot_per_warp" readonly type="number"/>w/㎡
                                            </div>
                                        </div>
                                    </div>
                                    <div class="help">
                                        注：设计负荷为单位负荷结合层高、朝向等客观情况计算所得，如需调整请修改单位负荷。
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ol>
                </li>
            </ul>
            <div class="btn-wrap">
                <div class="add" @click="data.bShowFloorPop = true">增加楼层</div>
                <div class="next" @click="submit">下一步</div>
            </div>
        </div>
        <!-- 增加楼层 -->
        <div class="mask" v-if="data.bShowFloorPop" @click="data.bShowFloorPop = false"></div>
        <div class="pop" v-if="data.bShowFloorPop">
            <div class="close-btn" @click="data.bShowFloorPop = false"></div>
            <h3>增加楼层</h3>
            <ul>
                <li :class="{ active: index == data.nFloorTypeIndex }" v-for="(item, index) in data.arrFloorType"
                    :key="item.id" @click="selectFloorType(index)">
                    {{ item.name }}
                </li>
            </ul>
            <div class="confirm" @click="confirmFloorType">确定</div>
        </div>

        <!-- 确认删除弹窗 -->
        <div class="mask" @touchmove.prevent v-if="data.bConfirmPopupShow">
            <div class="confirm-popup">
                <div class="popup-close" @click.stop="data.bConfirmPopupShow = false"></div>
                <div class="confirm-content">
                    <p>{{ data.sDelTips }}</p>
                </div>
                <div class="confirm-btn">
                    <button @click.stop="data.bConfirmPopupShow = false">
                        取消
                    </button>
                    <button @click.stop="popupConfirm()">确定</button>
                </div>
            </div>
        </div>
        <!-- 新版添加商品 -->
        <openis-shopp :title="'末端产品选型'" :bEditModalShow.sync="data.bSearchModalShow2" @confirm="selectChange"
                      :oGoodsInfo="data.oGoodsInfo"/>

        <!-- 温度选择 -->
        <awesome-picker ref="pickerwd" :anchor="data.arrAnchor" :data="data.arrNum"
                        :colorConfirm="data.oPicker.colorConfirm" @confirm="confirmPickerwd"></awesome-picker>
        <!-- 新版方位 -->
        <bearing :arrFw.sync="data.arrFw" :bBearing.sync="data.bBearing" @btnSumbit="btnSumbit"></bearing>
        <!-- 新版添加房间 -->
        <add-room :editFloorContentPopupShow.sync="data.editFloorContentPopupShow"
                  :arrEditFloorContent="data.arrEditFloorContent"
                  @floorContentPopupConfirm="floorContentPopupConfirm"></add-room>
    </div>
</template>
<script>
import oStorage from '@/libsV2/storage.js';
import bearing from "../end/components/bearing";
import {getRoom} from "@/js/ant/basicinfov2.js";
import {
    getAttr,
    getDire,
    getRoomEnergy,
    getDissipate,
    getStuyType,
    getFather,
    getAddRoom,
    getDelShopp, getDireBack
} from "@/js/ant/end.js";
import {objData} from "./data/objdata.js";
import oForm from "@/js/form.js";
import editModal from "@/components/editModal/index";
import openisShopp from "@/components/openisShopp/index";
import addRoom from "../end/components/addroom";

export default {
    components: {
        editModal,
        bearing,
        addRoom,
        openisShopp,
    },
    data() {
        return {
            data: objData(),
            // 是否编辑
            isEdit: this.$store.state.proposal.isEdit,
            // 填充完成
            bFullEnd: false,
        };
    },
    created() {
        this.$store.commit("loadSwitch", true);
        /* 初始化温度数据 0 - 51 */
        for (let i = 0; i < 51; i++) {
            this.data.arrNum.push({value: i});
        }

        $init(() => {
            /* 先获取风盘数据，后面区域需要根据区域冷负荷匹配风盘 */
            this.getWind().then(() => {
                Promise.all([
                    // 获取楼层、区域数据
                    this.getFloorHeating(),
                    this.getHeatSink(),
                    this.getReportInfo(),
                ]).then(() => {
                    this.$store.commit("loadSwitch", false);
                });
            });
        });
    },
    filters: {
        roomNumber(index) {
            return getRoom(index);
        },
    },
    computed: {
        /**
         * 是否允许编辑
         * @return {boolean}
         */
        canEdit() {
            return this.$store.getters["proposal/canEdit"]('end')
        },
    },
    methods: {
        //选择当前选型
        getType(findex, rindex, xinde, xitem) {
            let is_shopp = this.data.arrFloorArea[findex].rooms_init[rindex];
            getStuyType(xinde, is_shopp)
            this.data.objTypeXuan = xitem;
            // 删除完毕重新匹配所需商品
            this.count(findex, rindex, 0);
            this.$forceUpdate();
        },
        // 确认删除
        popupConfirm() {
            if (this.data.bDelFloor) {
                /* 删除楼层， 调用删除楼层接口*/
                this.$store.commit("loadSwitch", true);
                oForm.delRoom({report_sub_id: this.data.nFloorId}).then((res) => {
                    this.data.arrFloorArea.splice(this.data.nFindex, 1);
                    this.$store.commit("loadSwitch", false);
                    // 删除完成，数据初始化
                    this.data.nFloorId = 0;
                    this.data.nFindex = 0;
                    this.data.bDelFloor = false;
                });
            } else if (this.data.bDelArea) {
                /* 删除区域 */
                this.data.arrFloorArea[this.data.nFindex].rooms_init.splice(
                    this.data.nRindex,
                    1
                );
                // 删除完成，数据初始化
                this.data.nFindex = 0;
                this.data.nRindex = 0;
                this.data.bDelArea = false;
            }
            // 关闭删除提示弹窗
            this.data.bConfirmPopupShow = false;
        },
        // 删除楼层
        delRoom(id, index) {
            this.data.sDelTips = "删除当前楼层吗？";
            this.data.nFloorId = id;
            this.data.nFindex = index;
            this.data.bConfirmPopupShow = true;
            this.data.bDelFloor = true;
        },
        // 选择温度
        confirmPickerwd(res) {
            let _that = this;
            let nNum = res[0].value;
            _that.data.arrFloorArea[_that.data.nFindex].rooms_init[
                _that.data.nRindex
                ].temperature = nNum;
            _that.count(_that.data.nFindex, _that.data.nRindex, 1);
        },
        // 打开温度Picker
        openwdPicker(findex, rindex) {
            let _that = this;
            _that.data.nFindex = findex;
            _that.data.nRindex = rindex;
            _that.$refs.pickerwd.show();
        },
        //新版选择方位
        btnSumbit(e) {
            let _that = this;
            _that.data.arrFloorArea[_that.data.nFindex].rooms_init[
                _that.data.nRindex
                ].direction = e.value;
            _that.count(_that.data.nFindex, _that.data.nRindex, 1);
        },
        //新版打开方位
        openBearing(findex, rindex) {
            let _that = this;
            _that.data.nFindex = findex;
            _that.data.nRindex = rindex;
            _that.data.bBearing = true;
        },
        //新版修改风盘
        newEditWind(findex, rindex, windex, it, arrWind, energy_cold) {
            this.data.nFindex = findex;
            this.data.nRindex = rindex;
            this.data.nWindex = windex;
            this.data.oGoodsInfo = {
                goods_type_id: it.new_goods_type_id, // 分类id
                arrWind: [arrWind[windex]], // 商品数组
                energy_cold: energy_cold, //区域冷负荷
                bFloor: false, //是否需要选择楼层
            };
            let arrSetWind = [];
            arrWind.forEach((it, index) => {
                if (index != windex) {
                    arrSetWind.push(it);
                }
            });
            // localStorage.setItem("arrshopp", JSON.stringify(arrSetWind));
            oStorage.setStorage("arrshopp", JSON.stringify(arrSetWind));
            // 关闭选择产品弹窗
            this.data.bSearchModalShow2 = true;
        },
        //删除风盘
        newDelWind(findex, rindex, windex) {
            let is_shopp = this.data.arrFloorArea[findex].rooms_init[rindex];
            is_shopp.product.splice(windex, 1);
            is_shopp.arrWind.splice(windex, 1);
            getDelShopp(is_shopp);
        },
        // 选择商品
        selectChange(item) {
            //检查当前商品中是否有地暖管或者地暖系统
            let is_shopp =
                this.data.arrFloorArea[this.data.nFindex].rooms_init[this.data.nRindex];
            // let arrGetShopp = JSON.parse(localStorage.getItem("arrshopp"));
            let arrGetShopp = JSON.parse(oStorage.getStorage("arrshopp"));
            //商品中地暖
            let arrDnShopp = arrGetShopp.filter((it) => {
                return it.new_goods_type_id == 216;
            });
            //商品中地暖系统
            let arrDnxtShopp = arrGetShopp.filter((it) => {
                return it.id == 936;
            });
            //商品中的散热
            let arrSrShopp = arrGetShopp.filter((it) => {
                return it.new_goods_type_id == 215;
            });
            //选择商品中是否有不能同时存在的东西
            //选择商品中的地暖
            let arrDnItemData = item.data.filter((it) => {
                return it.new_goods_type_id == 216;
            });
            //选择商品中的散热
            let arrSrItemData = item.data.filter((it) => {
                return it.new_goods_type_id == 215;
            });
            //选择商品中的地暖系统
            let arrDnxtItemData = item.data.filter((it) => {
                return it.id == 936;
            });
            if (arrDnShopp.length && arrSrItemData.length) {
                this.$toast(`已经选择地暖管,请勿添加散热片`);
                return false;
            }
            if (arrSrShopp.length && arrDnItemData.length) {
                this.$toast(`已经选择散热片,请勿添加地暖管`);
                return false;
            }
            if (arrDnShopp.length && arrDnxtItemData.length) {
                this.$toast(`已经选择地暖管,请勿添加地暖系统`);
                return false;
            }
            if (arrDnxtShopp.length && arrDnItemData.length) {
                this.$toast(`已经选择地暖系统,请勿添加地暖管`);
                return false;
            }
            is_shopp.product.splice(this.data.nWindex, 1);
            is_shopp.arrWind.splice(this.data.nWindex, 1);
            item.data.forEach((it) => {
                is_shopp.product.push({product_id: it.id, num: it.nNum});
                let num = it.nNum;
                for (var i = 0; i < num; i++) {
                    let numData = {
                        nNum: 1,
                    };
                    let itObj = Object.assign(it, numData);
                    is_shopp.arrWind.push(itObj);
                    getDelShopp(is_shopp);
                }
            });
        },
        // 添加楼层
        floorAdd(data) {
            this.$store.commit("loadSwitch", true);
            oForm.roomAdd(data).then((res) => {
                this.$store.commit("loadSwitch", false);
                let oItem = res.data.data.result;
                this.data.arrFloorArea.push(oItem);
            });
        },
        // 展开房间详情
        openRoomDetail(rit) {
            this.$set(rit, "isOpen", !rit.isOpen);
        },
        // 新增区域选择
        selectArea(index) {
            this.data.nAreaIndex = index;
        },
        // 新增楼层选择
        selectFloorType(index) {
            this.data.nFloorTypeIndex = index;
        },
        // 删除区域
        delArea(pindex, cindex) {
            this.data.nFindex = pindex;
            this.data.nRindex = cindex;
            this.data.bDelArea = true;
            this.data.sDelTips = "删除当前区域吗？";
            this.data.bConfirmPopupShow = true;
        },
        // 打开添加区域弹窗
        openAddArea(index) {
            this.data.nFindex = index;
            this.data.arrEditFloorContent.floor = [];
            //新版选择房间，添加房间
            this.data.editFloorContentPopupShow = true;
        },
        //确认添加的房间
        floorContentPopupConfirm(e) {

            let arrTtem = e.floor;
            arrTtem.forEach((it) => {
                if (
                    it.key == "num_toilet" ||
                    // it.key == "num_kitchen" ||
                    it.key == "num_veranda"
                ) {
                    it.noMatch = true; //是否展示  厨房、卫生间、阳台
                }
                /* 初始化区域数据 */
                it.room_id = it.id;
                it.area = it.area || ""; //房间面积
                it.temperature = 20; //房间温度
                it.floor = 3; //房间层高  默认3米
                it.direction = ""; //房间朝向
                ///地下区域朝向默认为’无‘
                if (this.data.arrFloorArea[this.data.nFindex].room < 1) {
                    it.direction = "无/未知";
                }
                it.arrWind = []; //房间商品
                it.product = []; //房间商品id，数量
                it.typeXuan = [
                    {name: "风盘", open: true, id: 1},
                    {name: "散热", open: false, id: 2},
                    {name: "地暖", open: false, id: 3},
                ];
                let energy = {
                    name: it.name,
                    room_id: it.id,
                    area: it.area,
                    temperature: it.temperature,
                    floor: 3,
                    direction: this.getDirection(it),
                    energy_cold_per: it.energy_cold_per,
                    energy_hot_per: it.energy_hot_per,
                };
                let oData = {
                    report_id: this.$store.state.nAntReportId,
                    city_id: this.data.city_id,
                    energy: JSON.stringify(energy),
                    warm_keep: this.data.objInfo.warm_keep,
                    warm_length: this.data.objInfo.warm_length,
                };
                this.$store.commit("loadSwitch", true);
                // 调用负荷计算接口
                oForm.roomEnergy(oData).then((res) => {
                    let oRes = res.data.data.result;
                    let objRes = getRoomEnergy(oRes, it.area);
                    for (let key in objRes) {
                        it[key] = objRes[key]
                    }
                    this.$store.commit("loadSwitch", false);
                    // 楼层添加区域
                    this.data.objTypeXuan = {name: "风盘", open: true, id: 1};
                    this.data.arrFloorArea[this.data.nFindex].rooms_init.push(it);
                    let nRindex = this.data.arrFloorArea[this.data.nFindex].rooms_init.length;
                    this.getMatching(this.data.nFindex, nRindex - 1, 0);
                });
            });
            this.data.editFloorContentPopupShow = false;
        },
        // 确认添加楼层
        confirmFloorType() {
            let arrRoom = [];
            let oData = {
                report_id: this.$store.state.nAntReportId,
            };
            let oObj = {};
            /* 获取所有楼层id */
            this.data.arrFloorArea.forEach((it) => {
                arrRoom.push(it.room);
            });


            /* nFloorTypeIndex ： 0添加楼层 ， 1添加地下室 */
            oObj = getAddRoom(this.data.nFloorTypeIndex, arrRoom);
            oData.rooms = JSON.stringify(oObj);

            // 需调用添加楼层接口
            this.floorAdd(oData);
            this.data.bShowFloorPop = false;
        },
        //东南西北参数
        getDirection(it) {
            return getDire(it);
        },
        // 计算
        count(findex, rindex, from = 0) {
            /* 所有值都为必填 */
            let _that = this;
            let arrFloorArea = _that.data.arrFloorArea[findex].rooms_init[rindex];
            if (
                arrFloorArea.area &&
                arrFloorArea.temperature &&
                arrFloorArea.floor &&
                arrFloorArea.energy_cold_per &&
                arrFloorArea.energy_hot_per
            ) {
                let energy = {
                    name: arrFloorArea.name,
                    room_id: arrFloorArea.room_id,
                    area: arrFloorArea.area,
                    temperature: arrFloorArea.temperature,
                    floor: arrFloorArea.floor,
                    direction: _that.getDirection(arrFloorArea),
                    product_id: arrFloorArea.product_id,
                    energy_cold_per: arrFloorArea.energy_cold_per,
                    energy_hot_per: arrFloorArea.energy_hot_per,
                };
                let oData = {
                    report_id: _that.$store.state.nAntReportId,
                    city_id: _that.data.nCityId,
                    energy: JSON.stringify(energy),
                    warm_keep: this.data.objInfo.warm_keep,
                    warm_length: this.data.objInfo.warm_length,
                };
                _that.$store.commit("loadSwitch", true);
                // 调用负荷计算接口
                oForm.roomEnergy(oData).then((res) => {
                    let oRes = res.data.data.result;
                    let objRes = getRoomEnergy(oRes, arrFloorArea.area);
                    for (let key in objRes) {
                        arrFloorArea[key] = objRes[key]
                    }
                    _that.getMatching(findex, rindex, from);
                    _that.$store.commit("loadSwitch", false);
                });
            }
        },
        getRoomNumber(index) {
            return getRoom(index)
        },
        //滚动条滚动
        getScrollTop(number = 0, time) {
            let that = this;
            if (!time) {
                document.body.scrollTop = document.documentElement.scrollTop = number;
                return number;
            }

            const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
            let spacingInex = time / spacingTime; // 计算循环的次数
            let nowTop = document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
            let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
            let scrollTimer = setInterval(() => {
                if (spacingInex > 0) {
                    spacingInex--;
                    that.getScrollTop((nowTop += everTop));
                } else {
                    clearInterval(scrollTimer); // 清除计时器
                }
            }, spacingTime);
        },
        /**
         * 填充历史数据
         * @return
         */
        fullHisData() {

            this.bFullEnd = true;
            const {sub} = this.$store.getters["proposal/endInfo"]();
            // 创建默认的区域视图数据
            const createDefaultInit = (room) => {
                const ro = {};
                // 默认不展示类型
                const noType = ["num_toilet", "num_veranda"];
                if (noType.includes(ro.key)) ro.noMatch = true;
                /* 初始化数组 */
                ro.isOpen = false; // 是否展开
                ro.typeXuan = [
                    {name: "风盘", open: true, id: 1},
                    {name: "散热片", open: false, id: 2},
                    {name: "地暖", open: false, id: 3},
                ];
                return {...room, ...ro};
            }

            // 填充楼层信息
            this.data.arrFloorArea = this.data.arrFloorArea.map(floor => {

                // choose rooms
                const {rooms, rooms_choose, rooms_init} = sub.find(item => item.id === floor.id);

                // 拿到有选型数据的所有区域
                const allSubRooms = [...rooms_choose, ...rooms_init, ...rooms];
                const allSubRoomsMap = new Map();
                allSubRooms.forEach(room => {
                    allSubRoomsMap.set(room.name, room);
                });

                // 拿到原始的所有区域
                const allFloorRoomsMap = new Map();
                [...floor.rooms_choose, ...floor.rooms, ...floor.rooms_init].forEach(room => {
                    allFloorRoomsMap.set(room.name, room);
                });

                // 取出init中没有的区域填充入init
                const fullRooms = [];
                allFloorRoomsMap.forEach(floorRoom => {
                    const has = floor.rooms_init.find((i) => i.name === floorRoom.name);
                    !has && fullRooms.push(createDefaultInit(floorRoom));
                });
                floor.rooms_init.push(...fullRooms);


                // 处理区域数据格式
                floor.rooms_init = floor.rooms_init.map((init) => {
                    // 远程数据
                    const sameSubRooms = allSubRoomsMap.get(init.name);

                    // 设备填充
                    init.arrWind = sameSubRooms.product || [];
                    init.product = JSON.parse(sameSubRooms.product_id || '[]');
                    // 朝向填充

                    init.direction = getDireBack(sameSubRooms);

                    // 是否地暖 type_id = 216, id = 3
                    if (init.arrWind.some(i => i.new_goods_type_id === 216
                    )) {
                        init.typeXuan = init.typeXuan.map(type => {
                            if (type.id === 3) {
                                type.open = true;
                            }
                            return type;
                        });
                    }
                    // 是否风暖type_id = 215, id = 2
                    if (init.arrWind.some(i => i.new_goods_type_id === 215
                    )) {
                        init.typeXuan = init.typeXuan.map(type => {
                            if (type.id === 2) {
                                type.open = true;
                            }
                            return type;
                        });
                    }
                    // 计算负荷
                    init = {...init, ...getRoomEnergy(sameSubRooms, sameSubRooms.area),}
                    return init;
                });

                return floor;
            });

        },
        // 提交
        async submit() {
            let nReportId = this.$store.state.nAntReportId;
            // let nEditId = this.$store.state.proposal.oldDetailInfo.edit_id;
            if (!nReportId) {
                this.$toast("报告id错误！");
                return false;
            }
            let noWind = "";
            let oFloorItem = this.data.arrFloorArea.find((it) => {
                let oAreaItem = it.rooms_init.find((sit) => {
                    return !sit.product.length;
                });
                noWind = oAreaItem;
                return oAreaItem;
            });
            if (oFloorItem && !noWind.noMatch) {
                this.$toast(`${oFloorItem.name}${noWind.name}未匹配风盘`);
                return false;
            }
            let arrRoomId = [];
            let arrTips = [];
            this.data.arrFloorArea.forEach((item) => {
                item.name = this.getRoomNumber(item.room);
                item.rooms_init.forEach((it) => {
                    if (!it.direction && !it.noMatch && item.room > 0) {
                        arrRoomId.push('rooms' + it.id);
                        arrTips.push(`${item.name}的${it.name}未选择朝向！`);
                    }
                });
            });
            if (arrTips.length !== 0) {
                let nChoiceTop = this.$refs[arrRoomId[0]][0].offsetTop
                this.getScrollTop(nChoiceTop - 30, 200);
                this.$toast(arrTips[0]);
                this.data.selatShow = true;
                return false;
            }
            //在编辑的情况下，如果创建了新的草稿
            if (this.isEdit === 2) {
                this.$store.commit("loadSwitch", true);

                await oForm.reportEnergy(this.getFormRequestData());

                this.$store.commit("loadSwitch", false);

            } else {
                if (this.checkEditEd()) {

                    this.$store.commit("loadSwitch", true);

                    await oForm.reportEnergy(this.getFormRequestData());

                    this.$store.commit("loadSwitch", false);
                    this.$store.commit({type: 'proposal/CHANGE_EDIT_STATE', edit: 3});
                }
            }


            this.$router.replace("/ant/selection/v2");

        },
        // 获取请求参数
        getFormRequestData() {
            let nReportId = this.$store.state.nAntReportId;
            let nEditId = this.$store.state.proposal.oldDetailInfo.edit_id;
            // 整理数据
            let oData = {
                // 在编辑的情况下，如果创建了新的草稿，取草稿id
                report_id: this.canEdit ? this.isEdit === 2 ? nEditId || nReportId : nReportId : nReportId,
                is_edit: 0,
            };
            let nArea = 0;
            let arrEnergy = [];
            this.data.arrFloorArea.forEach((it) => {
                let oItem = {};
                oItem.report_sub_id = it.id;
                oItem.room = it.room;
                let energy = [];

                it.rooms_init.forEach((rit) => {

                    rit.product = rit.arrWind.map(i => ({
                        num: i.num || i.nNum,
                        product_id: i.product_id || i.id
                    }));

                    nArea += Number(rit.area);
                    energy.push({
                        name: rit.name,
                        room_id: rit.room_id,
                        area: rit.area,
                        temperature: rit.temperature,
                        floor: rit.floor,
                        direction: this.getDirection(rit),
                        product: rit.product,
                        num: rit.nNum,
                        common_use: rit.common_use,
                        energy_cold: rit.energy_cold,
                        energy_hot: rit.energy_hot,
                        energy_cold_per: rit.energy_cold_per,
                        energy_hot_per: rit.energy_hot_per,
                    });
                });
                oItem.energy = energy;
                arrEnergy.push(oItem);
            });
            oData.energy = JSON.stringify(arrEnergy);
            return oData;
        },
        /**
         * 校验是否编辑过内容
         * @returns {boolean}
         */
        checkEditEd() {
            this.$store.commit('loadSwitch', true);
            const targetData = JSON.stringify(this.getFormRequestData());
            this.fullHisData();
            this.fullHisData();
            const hisData = JSON.stringify(this.getFormRequestData());
            this.$store.commit('loadSwitch', false);
            return targetData === hisData ? null : JSON.parse(targetData);
        },
        //获取散热片
        getHeatSink() {
            return oForm.getHeatSink().then((res) => {
                let arrHeatSink = res.data.data.result;
                arrHeatSink = getAttr(arrHeatSink)
                this.data.arrHeatSink = arrHeatSink;
            });
        },
        //获取地暖
        getFloorHeating() {
            return oForm.getFloorHeating().then((res) => {
                let arrFloorHeating = res.data.data.result;
                arrFloorHeating = getAttr(arrFloorHeating)
                let arrShoppHeat = arrFloorHeating.filter((it) => {
                    return it.id == 970;
                });
                this.data.arrShoppHeat = arrShoppHeat;
            });
        },
        // 获取风盘
        getWind() {
            return new Promise((resolve, reject) => {
                oForm.getWind().then((res) => {
                    let arrWind = res.data.data.result;
                    arrWind = getAttr(arrWind)
                    this.data.arrWind = arrWind;
                    resolve();
                });
            });
        },
        // 获取城市信息
        getCityInfo(id) {
            oForm.getCityInfo({id}).then((res) => {
                this.sTemperature = res.data.data.result.avg_wind;
                this.$store.commit("loadSwitch", false);
            });
        },
        // 获取配置信息
        getConfig() {
            oForm.getConfigInfo({city_id: this.data.nCityId}).then((res) => {
                this.data.arrEditFloorContent.allTagContent = [
                    {
                        name: "室",
                        type: 0,
                        allTags: [],
                    },
                    {
                        name: "厅",
                        type: 1,
                        allTags: [],
                    },
                    {
                        name: "卫",
                        type: 2,
                        allTags: [],
                    },
                    {
                        name: "厨",
                        type: 3,
                        allTags: [],
                    },
                    {
                        name: "其他",
                        type: 4,
                        allTags: [],
                    },
                ];
                let arrPzArea = res.data.data.result.room;
                arrPzArea.forEach((item) => {
                    this.data.arrEditFloorContent.allTagContent.forEach((_) => {
                        // 全部
                        if (_.type === item.type) {
                            _.allTags.push({
                                ...item,
                                number: 1, // 增加编号
                                isNumber: 0, // 是否展示标签序号
                                area: "", // 增加面积
                                common_use: 1, // 增加非频繁使用空间样式字段默认1， 0:代表是非频繁空间
                            });
                        }
                    });
                });
                this.data.arrArea = res.data.data.result.room;
            });
        },
        //获取匹配风盘
        getMatching(findex, rindex, from) {
            let _that = this;
            let arrRooms = _that.data.arrFloorArea[findex].rooms_init[rindex];
            arrRooms.product = [];
            //判断选中选型中是否有风盘，有则执行下方匹配合适风盘
            let oneFpTpeList = arrRooms.typeXuan.filter((tit) => {
                return tit.id == 1 && tit.open == true;
            });
            //判断选中选型中是否有地暖，有则执行下方匹配合适地暖系统
            let oneDrTpeList = arrRooms.typeXuan.filter((tit) => {
                return tit.id == 3 && tit.open == true;
            });
            //判断选中选型中是否有散热，有则执行下方匹配合适散热系统
            let oneSrTpeList = arrRooms.typeXuan.filter((tit) => {
                return tit.id == 2 && tit.open == true;
            });
            if (
                (oneFpTpeList.length && this.data.objTypeXuan.id == 1) ||
                (oneFpTpeList.length && from == 1)
            ) {
                // 匹配风盘
                getFather(arrRooms, _that.data.arrWind)
                this.$forceUpdate();
            }
            if (
                (oneDrTpeList.length && this.data.objTypeXuan.id == 3) ||
                (oneDrTpeList.length && from == 1)
            ) {
                let arrFter = arrRooms.arrWind.filter((it) => {
                    return it.new_goods_type_id == 216;
                });
                if (arrFter.length) {
                    // 216 为散热  215为地暖  201为风盘
                    // 判断是否有散热器  有的话删除  散热不与地暖共同存在
                    for (var i = arrRooms.arrWind.length - 1; i >= 0; i--) {
                        if (arrRooms.arrWind[i].new_goods_type_id == 216) {
                            arrRooms.arrWind.splice(i, 1);
                        }
                    }
                }
                if (this.data.arrShoppHeat.length) {
                    arrRooms.arrWind.push(this.data.arrShoppHeat[0]);
                    this.$forceUpdate();
                } else {
                    this.$toast("暂无地暖系统！");
                    arrRooms.typeXuan.forEach((xit) => {
                        if (xit.id == 3) {
                            xit.open = false;
                        }
                    });
                }
            }
            //匹配散热
            if (
                (oneSrTpeList.length && this.data.objTypeXuan.id == 2) ||
                (oneSrTpeList.length && from == 1)
            ) {
                let arrFter = arrRooms.arrWind.filter((it) => {
                    return it.new_goods_type_id == 215;
                });
                if (arrFter.length) {
                    // 216 为散热  215为地暖  201为风盘
                    // 判断是否有地暖  有的话删除  散热不与地暖共同存在
                    for (var i = arrRooms.arrWind.length - 1; i >= 0; i--) {
                        if (arrRooms.arrWind[i].new_goods_type_id == 215) {
                            arrRooms.arrWind.splice(i, 1);
                        }
                    }
                }
                //散热匹配方法
                getDissipate(arrRooms, this.data.arrHeatSink)
            }
            // 商品id
            let arrProduct = [];
            arrRooms.arrWind.forEach((it) => {
                arrProduct.push({
                    product_id: it.id,
                    num: it.nNum,
                });
            });
            arrRooms.product = arrProduct;
            this.canEdit && !this.bFullEnd && this.isEdit < 2 && this.fullHisData();
        },
        // 获取报告详情
        getReportInfo() {
            let _that = this;
            let nReportId = _that.$store.state.nAntReportId;
            if (!nReportId) {
                _that.$toast("报告id错误！");
                return false;
            }
            let oData = {
                report_id: nReportId,
                show_sub: 1,
                show_room: 1,
                init_room: 1,
                check_room: 1,
                // is_edit: this.canEdit ? 1 : 0,
                is_edit: 0,
            };
            return new Promise((resolve) => {
                oForm.getReportInfo(oData).then((res) => {
                    let oInfo = res.data.data.result;
                    _that.data.nCityId = oInfo.city_id;
                    oInfo.sub.forEach((it, findex) => {
                        it.rooms_init.forEach((sit, rindex) => {
                            // 默认不展示 厨房、卫生间、阳台
                            if (
                                sit.key == "num_toilet" ||
                                // sit.key == "num_kitchen" ||
                                sit.key == "num_veranda"
                            ) {
                                sit.noMatch = true; //是否展示  厨房、卫生间、阳台
                            }
                            /* 初始化数组 */
                            sit.isOpen = false; // 是否展开
                            sit.area = parseFloat(sit.area);
                            sit.typeXuan = [
                                {name: "风盘", open: true, id: 1},
                                {name: "散热片", open: false, id: 2},
                                {name: "地暖", open: false, id: 3},
                            ];
                            sit.temperature = 20;
                            sit.floor = oInfo.floor;
                            sit.direction = "";
                            sit.product = [];
                            sit.arrWind = [];
                            ///地下区域朝向默认为’无‘
                            if (it.room < 1) {
                                sit.direction = "无/未知";
                            }
                            let energy = {
                                name: sit.name,
                                room_id: sit.room_id,
                                area: sit.area,
                                temperature: sit.temperature,
                                floor: oInfo.floor,
                                direction: _that.getDirection(sit),
                                energy_cold_per: sit.energy_cold_per,
                                energy_hot_per: sit.energy_hot_per,
                            };
                            let oData = {
                                report_id: nReportId,
                                city_id: oInfo.city_id,
                                energy: JSON.stringify(energy),
                                warm_keep: oInfo.warm_keep,
                                warm_length: oInfo.warm_length,
                            };
                            _that.$store.commit("loadSwitch", true);
                            // 调用负荷计算接口
                            oForm.roomEnergy(oData).then((res) => {
                                let oRes = res.data.data.result;
                                let objRes = getRoomEnergy(oRes, sit.area);
                                for (let key in objRes) {
                                    sit[key] = objRes[key]
                                }
                                _that.$store.commit("loadSwitch", false);
                                this.getMatching(findex, rindex, 0);
                            });
                        });
                    });
                    _that.getCityInfo(oInfo.city_id);
                    _that.getConfig();
                    _that.data.arrFloorArea = oInfo.sub;
                    _that.data.objInfo = oInfo;
                    resolve();
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
